import { sample } from 'effector';

import { $currentUser } from 'entities/currentUser';
import { getModalFactory } from 'entities/modalFactory';

import { debounce } from 'patronum';

export const { $isModalOpen, openModal, closeModal } = getModalFactory();

const shouldOpenModal = sample({
  source: $currentUser,
  filter: (user) => !!user?.hasSurvey,
});

const debouncedOpenModal = debounce({
  source: shouldOpenModal,
  timeout: 3000,
});

sample({
  source: debouncedOpenModal,
  target: openModal,
});
